<template>
  <v-row v-if="!isProSubscriber && !isEnterpriseSubscriber" my-4 justify="start">
    <v-col cols="12" xl="6">
      <v-alert :value="true" type="info" class="d-inline-flex text-body-2">
        <slot>
          Requires PRO subscription.
          <a style="color: #fff033" href="/pricing" target="_blank">Subscribe now</a> and get the
          full potential WhaleWisdom offers!
        </slot>
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>
import { useUserStore } from '@/store'

export default {
  computed: {
    isProSubscriber() {
      return useUserStore().isProSubscriber
    },
    isEnterpriseSubscriber() {
      return useUserStore().isEnterpriseSubscriber
    }
  }
}
</script>
